import { twMerge } from "tailwind-merge";

export const treeClassName = twMerge(
  "bg-transparent",

  "[&_.ant-tree-treenode]:w-full [&_.ant-tree-treenode]:items-stretch",
  "[&_.ant-tree-treenode]:mb-2 [&_.ant-tree-treenode]:!p-0",

  "[&_.ant-tree-indent]:shrink-0",

  "[&_.ant-tree-switcher]:relative [&_.ant-tree-switcher]:z-10",
  "[&_.ant-tree-switcher]:!w-9 [&_.ant-tree-switcher]:-mr-9",
  "[&_.ant-tree-switcher]:flex [&_.ant-tree-switcher]:items-center",
  "[&_.ant-tree-switcher]:justify-center [&_.ant-tree-switcher]:!bg-transparent",
  "[&_.ant-tree-switcher]:text-[--palette-neutral-6]",
  "[&_.ant-tree-switcher::before]:!hidden",

  "[&_.ant-tree-node-content-wrapper]:flex [&_.ant-tree-node-content-wrapper]:items-center",
  "[&_.ant-tree-node-content-wrapper]:min-w-0 [&_.ant-tree-node-content-wrapper]:overflow-hidden",
  "[&_.ant-tree-node-content-wrapper]:min-h-14 [&_.ant-tree-node-content-wrapper]:py-2",
  "[&_.ant-tree-node-content-wrapper]:pl-9 [&_.ant-tree-node-content-wrapper]:pr-3",
  "[&_.ant-tree-node-content-wrapper]:rounded-lg [&_.ant-tree-node-content-wrapper]:border",
  "[&_.ant-tree-node-content-wrapper]:border-[--palette-neutral-2]",
  "[&_.ant-tree-node-content-wrapper:hover]:!bg-[--palette-neutral-0]",

  "[&_.ant-tree-node-content-wrapper.ant-tree-node-selected]:!bg-[--palette-primary-1]",
  "[&_.ant-tree-node-content-wrapper.ant-tree-node-selected]:border-[--palette-primary-3]",
  "[&_.ant-tree-node-content-wrapper.ant-tree-node-selected]:shadow-[inset_3px_0_0_0_var(--palette-primary-6)]",

  // Состояние перетаскивания приходит data-атрибутами из `TreeNodeDnd` внутри строки.
  "[&_.ant-tree-node-content-wrapper:has([data-dragging])]:opacity-50",
  "[&_.ant-tree-node-content-wrapper:has([data-drop-target])]:!bg-[--palette-success-1]",
  "[&_.ant-tree-node-content-wrapper:has([data-drop-target])]:border-[--palette-success-5]",

  "[&_.ant-tree-node-content-wrapper_.ant-tree-title]:block",
  "[&_.ant-tree-node-content-wrapper_.ant-tree-title]:w-full",
  "[&_.ant-tree-node-content-wrapper_.ant-tree-title]:min-w-0",
);
